<template>
  <bm-overlay
    ref="customOverlay"
    :class="[isweixing ? 'sample' : 'sample2']"
    pane="labelPane"
    @draw="draw"
  >
    <div class="name" v-text="text" @click="handleClick"></div>
  </bm-overlay>
</template>

<script>
export default {
  props: ["text", "text2", "position", "active", "danWei", "isweixing"],
  watch: {
    position: {
      handler() {
        this.$refs.customOverlay.reload();
      },
      deep: true,
    },
  },
  methods: {
    handleClick() {
      //   global.alert('Well done.')
    },
    draw({ el, BMap, map }) {
      const { lng, lat } = this.position;
      const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat));
      el.style.left = pixel.x - 50 + "px";
      el.style.top = pixel.y - 50 + "px";
    },
  },
};
</script>


<style scoped>
.sample {
  min-width: 200px;
  height: 42px;
  line-height: 40px;
  color: #ffffff;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  position: absolute;
  border-radius: 10px;
  padding-top: -5px;
}
.sample2 {
  min-width: 200px;
  height: 42px;
  line-height: 40px;
  color: #000000;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  position: absolute;
  border-radius: 10px;
  padding-top: -5px;
}

.name {
  position: absolute;
  width: 100%;
  top: 5%;
  text-align: center;
}
.mianji {
  position: absolute;
  width: 100%;
  line-height: 16px;
  top: 24px;
}
</style>
